export default __webpack_public_path__ + "static/media/translate_icon.88813b4e.svg";